import SvgIcon from '@mui/material/SvgIcon';
import * as React from 'react';
const SvgCheckCircleOutlined = (props)=>/*#__PURE__*/ React.createElement(SvgIcon, {
        ...props,
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M11.571 14.946a.987.987 0 0 1-1.392 0l-2.25-2.25a.987.987 0 0 1 0-1.392.987.987 0 0 1 1.392 0l1.554 1.554 3.804-3.804a.987.987 0 0 1 1.392 0 .987.987 0 0 1 0 1.392zM21 12a9 9 0 0 1-9 9 9 9 0 0 1-9-9 9 9 0 0 1 9-9 9 9 0 0 1 9 9m-9-7.312A7.31 7.31 0 0 0 4.688 12 7.31 7.31 0 0 0 12 19.313 7.31 7.31 0 0 0 19.313 12 7.31 7.31 0 0 0 12 4.688"
    }));
export default SvgCheckCircleOutlined;
